export * from './testimonial-component-config.interface';
export * from './testimonial-column-count.enum';
